import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { JudgeScoresInfo, TieBreakerWindow } from '../../application/application.service';

@Component({
    selector: 'dialog-tiebreaker-component',
    templateUrl: 'tiebreaker.dialogcomponent.html',
    styleUrls: ['tiebreaker.dialogcomponent.scss']
})

export class TieBreakerDialogComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    Nominees: JudgeScoresInfo[];
    TieForm: FormGroup;
    WindowNeeded: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<TieBreakerDialogComponent>,
        private fb: FormBuilder) { }

    ngOnInit() {
        this.Nominees = this.data.Options.tiedNominees;
        this.WindowNeeded = this.data.Options.windowNeeded;

        this.TieForm = this.fb.group({
            BeginDate: [null, Validators.required],
            BeginTime: [null, [Validators.required, Validators.pattern(/^(0?[1-9]|1[0-2]):[0-5]\d [aApP][mM]$/)]],
            EndDate: [null, Validators.required],
            EndTime: [null, [Validators.required, Validators.pattern(/^(0?[1-9]|1[0-2]):[0-5]\d [aApP][mM]$/)]],
            AutoAssign: [false]
        });

        if (!this.WindowNeeded) {
            this.TieForm.get('BeginDate').disable();
            this.TieForm.get('BeginTime').disable();
            this.TieForm.get('EndDate').disable();
            this.TieForm.get('EndTime').disable();
        }
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    Submit(form: FormGroup) {
        if (form.invalid) {
            return;
        }

        //map as TieBreakerWindow
        let res = new TieBreakerWindow();

        if (form.value.BeginDate != null) {
            res.BeginDate = new Date(form.value.BeginDate.toLocaleDateString() + ' ' + form.value.BeginTime);
        }

        if (form.value.EndDate != null) {
            res.EndDate = new Date(form.value.EndDate.toLocaleDateString() + ' ' + form.value.EndTime);
        }

        res.AutoAssign = form.value.AutoAssign;

        this.dialogRef.close(res);
    }
}

export class BaseTieBreakerDialogOptions {
    tiedNominees: JudgeScoresInfo[];
    windowNeeded: boolean;
}
